import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { omit } from '../../util/object';
import { apiNewsTypeAdd, apiNewsTypeDelete, apiNewsTypeGet, apiNewsTypeUpdate, type NewsType } from '../api';

export const isEdit = (record: unknown) => Boolean(record && (<any>record).isEdit);

export interface IDataSource extends NewsType { }

export class NewsTypeService {
  dataSource: IDataSource[] = [];

  dataSourceLoading = false;

  @Loading<NewsTypeService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiNewsTypeGet();
    this.dataSource = data;
  }

  add() {
    this.dataSource.unshift({ id: getId() } as IDataSource);
  }

  async upsert(record: IDataSource) {
    if (record.id >= 0) {
      await apiNewsTypeUpdate(record);
    } else {
      await apiNewsTypeAdd(omit(record, ['id']));
    }
  }

  async del(id: IDataSource['id']) {
    if (id >= 0) await apiNewsTypeDelete(id);
    this.dataSource.splice(this.dataSource.findIndex(_ => _.id === id), 1);
  }
}

export const newsTypeService = new NewsTypeService();